export default __webpack_public_path__ + "static/media/game_tree.c8528154.png";